var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgTripsPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 830.8 499",
    viewBox: "0 0 830.8 499",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffaa3c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m824.5 198.1c10.9 38.9.5 78.7-22.7 111.1-103 160.2-336 243.6-507.6 146.5-48.3-29-92.8-45.6-105.4-100.6-6.4-27.9 34-65.1 31.1-181-2.5-101.1 61.8-123.4 156.2-159.7 47.4-21.3 98.9-12.6 146.4 4.3 151.9 41.4 252.6 30.9 302 179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.3 414.7c0 31.9-25 49.9-65.5 49.9s-78.3-19-78.3-50.9 34.8-59.7 75.3-59.7 68.5 28.9 68.5 60.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTripsPage);
export default __webpack_public_path__ + "static/media/bg_trips_page.b772ac27648f51541c09964785fb4e02.svg";
export { ForwardRef as ReactComponent };